<template>
  <div class="novidades-portal__header-card">
    <div class="novidades-portal__header-row">
      <div class="novidades-portal__header-intro">
        <div class="novidades-portal__badge-changelog">
          <v-icon x-small color="inherit">fas fa-magic</v-icon>
          <span>Changelog Oficial de Evolução</span>
        </div>
        <h1 class="novidades-portal__title">Novidades do Portal</h1>
        <p class="novidades-portal__subtitle">
          Aqui você confere as novidades liberadas para as soluções LifeApps,
          com melhorias em atendimento, catálogo, segurança, pagamentos e
          demais módulos da plataforma.
        </p>
      </div>
      <div class="novidades-portal__header-actions">
        <button
          type="button"
          class="novidades-portal__mark-all-btn"
          :disabled="unreadCount <= 0 || markAllLoading"
          :title="
            unreadCount > 0
              ? 'Marcar todas as novidades como lidas'
              : 'Todas as novidades já foram lidas'
          "
          @click="$emit('mark-all-read')"
        >
          <v-icon x-small>fas fa-check-double</v-icon>
          <span>Marcar todas como lidas</span>
          <span v-if="unreadCount > 0" class="novidades-portal__mark-all-count">
            {{ unreadCount > 99 ? "99+" : unreadCount }}
          </span>
        </button>
        <button
          type="button"
          class="novidades-portal__export-pdf-btn"
          @click="$emit('export-pdf')"
        >
          <v-icon x-small>fas fa-file-download</v-icon>
          <span>Exportar PDF</span>
        </button>
        <div class="novidades-portal__layout-toggle">
          <button
            type="button"
            class="novidades-portal__layout-btn"
            :class="{
              'novidades-portal__layout-btn--active': layoutMode === 'timeline'
            }"
            @click="$emit('update:layoutMode', 'timeline')"
          >
            <v-icon x-small>fas fa-layer-group</v-icon>
            <span>Linha do Tempo</span>
          </button>
          <button
            type="button"
            class="novidades-portal__layout-btn"
            :class="{
              'novidades-portal__layout-btn--active': layoutMode === 'grid'
            }"
            @click="$emit('update:layoutMode', 'grid')"
          >
            <v-icon x-small>fas fa-th</v-icon>
            <span>Grade de Cards</span>
          </button>
        </div>
      </div>
    </div>

    <div class="novidades-portal__filters-row">
      <div class="novidades-portal__search-wrap">
        <div class="novidades-portal__search-box">
          <v-icon x-small class="novidades-portal__search-box-icon">
            fas fa-search
          </v-icon>
          <input
            :value="searchQuery"
            type="search"
            class="novidades-portal__search-input"
            placeholder="Buscar por termo, recurso ou palavra-chave..."
            autocomplete="off"
            @input="onSearchInput"
          />
          <button
            v-if="searchQuery"
            type="button"
            class="novidades-portal__search-clear"
            @click="$emit('update:searchQuery', '')"
          >
            Limpar
          </button>
        </div>
      </div>
      <div class="novidades-portal__tags-scroll">
        <span class="novidades-portal__filter-label">
          <v-icon x-small class="mr-1">fas fa-filter</v-icon>
          Filtrar:
        </span>
        <button
          type="button"
          class="novidades-portal__chip"
          :class="{
            'novidades-portal__chip--all-active': !activeTag
          }"
          @click="onSelectAll"
        >
          Todas ({{ totalLoaded }})
        </button>
        <button
          v-for="tag in allTags"
          :key="tag"
          type="button"
          class="novidades-portal__chip"
          :class="{
            'novidades-portal__chip--tag-active': activeTag === tag
          }"
          @click="onToggleTag(tag)"
        >
          #{{ tag }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NovidadesPortalHeader",
  props: {
    layoutMode: {
      type: String,
      default: "timeline"
    },
    searchQuery: {
      type: String,
      default: ""
    },
    activeTag: {
      type: String,
      default: null
    },
    allTags: {
      type: Array,
      default: () => []
    },
    totalLoaded: {
      type: Number,
      default: 0
    },
    unreadCount: {
      type: Number,
      default: 0
    },
    markAllLoading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onSearchInput(event) {
      this.$emit("update:searchQuery", event.target.value || "");
    },
    onSelectAll() {
      this.$emit("update:activeTag", null);
    },
    onToggleTag(tag) {
      const next = this.activeTag === tag ? null : tag;
      this.$emit("update:activeTag", next);
    }
  }
};
</script>
